import { render, staticRenderFns } from "./detailSmsForm.vue?vue&type=template&id=eb96c1ae&scoped=true&"
import script from "./detailSmsForm.vue?vue&type=script&lang=js&"
export * from "./detailSmsForm.vue?vue&type=script&lang=js&"
import style0 from "./detailSmsForm.vue?vue&type=style&index=0&id=eb96c1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb96c1ae",
  null
  
)

export default component.exports